import type { JSX } from 'react';

import styles from './styles.module.css';

export function ProviderAbout(): JSX.Element {
  return (
    <section className={`${styles.secPad}`} id="about">
      <div className={styles.wrap}>
        <span className={styles.eyebrow}>About the program</span>
        <h2 className={styles.aboutHeading}>
          A fully digital benefit, built for the <span className={styles.coral}>ACCESS</span> model.
        </h2>
        <div className={styles.introTwo}>
          <div>
            <p className={styles.aboutPara}>
              NourishedRx is a 12-month digital nutrition program for Medicare beneficiaries on the
              CKM and eCKM tracks. When you refer an eligible patient, we verify their coverage,
              enroll them, and pair them with Betty — an AI health companion backed by registered
              dietitians — to drive real health improvement through personalized nutrition support.
            </p>
            <p className={styles.aboutPara}>
              Your patient gets daily support, nutrition education, recipes, optional prepared
              meals, and live RD group sessions — and you get updates without the administrative
              burden.
            </p>
          </div>
          <div className={styles.accessBox}>
            <h3>Why the referral starts with you</h3>
            <p>
              ACCESS enrollment requires <b>provider attribution</b> — a provider referral ensures
              successful care coordination and creates the record that lets your patient receive the
              benefit.
            </p>
            <p>
              Patients who find us directly are routed to ask <em>you</em> to refer them.
            </p>
          </div>
        </div>

        <div className={styles.engage}>
          <span className={styles.eyebrow}>An app patients actually use</span>
          <h3>Engaging support, built around your patient's own goals</h3>
          <p>
            Betty keeps members coming back with bite-sized support they look forward to — and helps
            them work toward goals they set for themselves, not goals imposed on them.
          </p>
          <div className={styles.engageGrid}>
            <div className={styles.ep}>
              <div className={styles.epIc}>
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                  <path d="M4 19V5a2 2 0 0 1 2-2h10l4 4v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
                  <path d="M8 9h6M8 13h8" />
                </svg>
              </div>
              <b>Education &amp; recipes</b>
              <p>Short lessons and recipes tailored to their conditions, in English or Spanish.</p>
            </div>
            <div className={styles.ep}>
              <div className={styles.epIc}>
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                  <path d="M3 12h4l2 5 4-12 2 7h6" />
                </svg>
              </div>
              <b>Meal logging</b>
              <p>Patients log meals and get instant, condition-specific tips back from Betty.</p>
            </div>
            <div className={styles.ep}>
              <div className={styles.epIc}>
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" />
                </svg>
              </div>
              <b>Tailored daily support</b>
              <p>Friendly check-ins that adapt to each member's life and progress.</p>
            </div>
            <div className={styles.ep}>
              <div className={styles.epIc}>
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                  <path d="M5 21V4M5 4h11l-2 4 2 4H5" />
                </svg>
              </div>
              <b>Goals they set</b>
              <p>Members choose their own goals and celebrate every win along the way.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
